(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockForecast', {
        templateUrl: 'views/components/views/stockForecast/stockForecast.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'stockForecastService', 'seasonalitiesService', 'forecastsService', 'layoutService', function ($stateParams, utilityService, stockForecastService, seasonalitiesService, forecastsService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let prodId = $stateParams.prod_id;
            let prodSizeKeyno = $stateParams.prodsize_keyno;
            let prodChoiceKeyno = $stateParams.prodchoice_keyno;
            let stockPlaceId = $stateParams.stockplace_id;

            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                chartType: 'line',
                chartLabels: '0',
                bgStockForecastMain: {
                    selected: 'SETTINGS',
                    buttons: [
                        { id: 'SETTINGS', label: 'bg_stockforecast_main_settings', color: 'primary', onClick: () => vm.model.bgStockForecastMain.selected = 'SETTINGS' },
                        { id: 'DISPLAY', label: 'bg_stockforecast_main_display', color: 'primary', onClick: () => vm.model.bgStockForecastMain.selected = 'DISPLAY' }
                    ]
                },
                bgStockForecastDisplayType: {
                    selected: 'GRAPH',
                    buttons: [
                        { id: 'GRAPH', label: 'bg_stockforecast_displaytype_graph', color: 'primary', onClick: () => vm.model.bgStockForecastDisplayType.selected = 'GRAPH' },
                        { id: 'LIST', label: 'bg_stockforecast_displaytype_list', color: 'primary', onClick: () => vm.model.bgStockForecastDisplayType.selected = 'LIST' }
                    ]
                },
                setting: {},
                selectListSeasonalities: [],
                selectListForecasts: [],
                selectListResolutions: [],
                forecastGraphList: {
                    records: []
                },
                itemsListForecastDatas: [],
                updatingForecast: false
            };

            // #endregion VARIABLES & DEFINITIONS
            
            // #region PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await stockForecastService.getSetting({
                    prod_id: prodId,
                    prodsize_keyno: prodSizeKeyno,
                    prodchoice_keyno: prodChoiceKeyno,
                    stockplace_id: stockPlaceId
                }))[0];
            }
            
            async function loadSeasonalities() {
                vm.model.selectListSeasonalities = await seasonalitiesService.listSeasonalities();
            }

            async function loadForecasts() {
                vm.model.selectListForecasts = await forecastsService.listForecasts();
            }

            async function loadResolutions() {
                vm.model.selectListResolutions = await stockForecastService.listResolutions();
            }
            
            function retrieveForecast() {
                if (utilityService.validateParmsValue(vm.model.setting.forecast_keyno) !== true) return;

                return stockForecastService.getForecast({ forecast_keyno: vm.model.setting.forecast_keyno }).then(function (response) {
                    vm.model.setting.forecast_type_id = response[0].forecast_type_id;
                    vm.model.setting.forecast_resolution_id = response[0].forecast_resolution_id;
                    vm.model.setting.forecast_forward_nbr = response[0].forecast_forward_nbr;
                    vm.model.setting.forecast_history_running_nbr = response[0].forecast_history_running_nbr;

                    if (response[0].forecast_type_id === 'F') {
                        vm.model.setting.history_fom_date = response[0].forecast_history_fixed_fom_date;
                        vm.model.setting.history_tom_date = response[0].forecast_history_fixed_tom_date;
                        vm.model.setting.forecast_forward_fixed_startdate = response[0].forecast_forward_fixed_startdate;
                    }
                });
            }
            
            function retrieveHistoryDates() {
                if (utilityService.validateParmsValue(vm.model.setting.forecast_resolution_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.forecast_history_running_nbr) !== true) return;
                
                return stockForecastService.getHistoryDates({
                    forecast_resolution_id: vm.model.setting.forecast_resolution_id,
                    forecast_history_running_nbr: vm.model.setting.forecast_history_running_nbr
                }).then(function (response) {
                    vm.model.setting.history_fom_date = response[0].history_fom_date;
                    vm.model.setting.history_tom_date = response[0].history_tom_date;
                });
            }
            
            function retrieveHistory() {
                if (utilityService.validateParmsValue(vm.model.setting.seasonality_keyno, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.history_fom_date) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.history_tom_date) !== true) return;

                return stockForecastService.getHistory(vm.model.setting).then(function (response) {
                    vm.model.setting.history_qty = response[0].history_qty;
                    vm.model.setting.history_pst = response[0].history_pst;
                });
            }
            
            function retrieveStockForecast() {
                vm.model.itemsListForecastDatas = [];

                return stockForecastService.listForecastDatas(vm.model.setting).then((list) => {
                    vm.model.itemsListForecastDatas = list;
                    vm.model.forecastGraphList.records = [];

                    vm.model.itemsListForecastDatas.forEach((data) => {
                        if (data) {
                            data.item_secondary[1].visible_chart = true;
                            data.item_secondary[1].name = 'item_col1';
                            data.item_secondary[3].visible_chart = true;
                            data.item_secondary[3].name = 'item_col3';

                            vm.model.forecastGraphList.records.push(data);
                        }
                    });
                });
            }

            // #endregion PROCEDURE CALLS

            // #region CREATE FUNCTION

            function createStockForecast() {
                stockForecastService.createUpdates(vm.model.setting).then(() => {
                    vm.model.updatingForecast = false;
                    retrieveStockForecast();
                }, () => vm.model.updatingForecast = false);
            }

            // #endregion CREATE FUNCTION

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgStockForecastMain = function (value) {
                vm.model.bgStockForecastMain.selected = value;

                if (vm.model.tabletSize.matches === false && vm.model.bgStockForecastMain.selected === 'DISPLAY') createStockForecast();
            };

            vm.selectBgStockForecastDisplayType = function (value) {
                vm.model.bgStockForecastDisplayType.selected = value;
            };

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region UPDATE FORECAST BUTTON FUNCTION

            vm.updateForecast = function () {
                vm.model.updatingForecast = true;

                if (vm.model.tabletSize.matches === true) createStockForecast();
            };

            // #endregion UPDATE FORECAST BUTTON FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'seasonality_keyno':
                    case 'history_fom_date':
                    case 'history_tom_date':
                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

                        vm.model.setting[id] = value;

                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        retrieveHistory();
                        break;
                    case 'forecast_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.setting.forecast_keyno) !== true) return;

                        vm.model.setting.forecast_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.setting.forecast_keyno) !== true) return;

                        retrieveForecast();
                        break;
                    case 'forecast_resolution_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.forecast_resolution_id) !== true) return;

                        vm.model.setting.forecast_resolution_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.forecast_resolution_id) !== true) return;

                        if (vm.model.setting.forecast_type_id === 'R') retrieveHistoryDates();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'forecast_history_running_nbr':
                        if (utilityService.validateParmsValue(vm.model.setting.forecast_history_running_nbr) !== true) return;

                        if (vm.model.setting.forecast_type_id === 'R') retrieveHistoryDates();
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadSeasonalities();
                loadForecasts();
                loadResolutions();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
